module.exports = __webpack_public_path__ + "img/logo-kbi.de18d72e.png";